export function TwoDigitsPipe() {
  return function (input) {
    if (input > 99) {
      input = '+∞';
    }

    return input;
  };
}
